module.exports = {"TXTCLI_More":{"id":"TXTCLI_More","defaultMessage":"Több","flags":["TRACK"],"track":"More"}}